import React from 'react';
import styles from './index.css';
import { rel } from '../../../utils/rel';
class CommentTextareaHead extends React.PureComponent {
    render() {
        const { commentUrl, count, joinCount, isCloseInteract } = this.props;
        return (React.createElement("div", { className: styles.comment_textarea_head },
            !isCloseInteract && (React.createElement("span", { className: styles.right_box },
                React.createElement("span", { className: styles.count },
                    React.createElement("a", { href: commentUrl, target: "_blank", rel: rel },
                        React.createElement("span", { className: styles.num }, count)),
                    React.createElement("span", { className: styles.txt }, " \u6761\u8BC4\u8BBA")),
                React.createElement("span", { className: styles.line }, "/"),
                React.createElement("span", { className: styles.count },
                    React.createElement("a", { href: commentUrl, target: "_blank", rel: rel },
                        React.createElement("span", { className: styles.num }, joinCount)),
                    React.createElement("span", { className: styles.txt }, " \u4EBA\u53C2\u4E0E")))),
            React.createElement("span", { className: styles.tips }, "\u7F51\u53CB\u8BC4\u8BBA"),
            React.createElement("span", { className: styles.tips }, "\uFF5C"),
            React.createElement("a", { href: "//gentie.ifeng.com/commentManage", target: "_blank", rel: rel, className: styles.tips }, "\u8DDF\u5E16\u7BA1\u7406"),
            React.createElement("span", { className: styles.tips }, "\uFF5C"),
            React.createElement("a", { href: "//gentie.ifeng.com/superviseReport", target: "_blank", rel: rel, className: styles.tips }, "\u4E3E\u62A5")));
    }
}
export default CommentTextareaHead;
